import { render, staticRenderFns } from "./RegisterMegacardSelector.vue?vue&type=template&id=3f8c3d75&scoped=true&"
import script from "./RegisterMegacardSelector.vue?vue&type=script&lang=ts&"
export * from "./RegisterMegacardSelector.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterMegacardSelector.vue?vue&type=style&index=0&id=3f8c3d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8c3d75",
  null
  
)

export default component.exports